import { Action } from '@reduxjs/toolkit'
import { getEmployeeDashboardsByUser } from './MainCRUD'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  DashboardsRequested: '[Request Dashboards] Main API',
  DashboardsLoaded: '[Load Dashboards] Main API',
  DashboardsFailed: '[Load Dashboards] Main API Failed',
  DashboardsCleared: '[Clear Dashboards] Main State',
}

export interface IMainState {
  dashboards: string[]
  loading: boolean
  error?: string
}

const initialMainState: IMainState = {
  dashboards: [],
  loading: false,
  error: undefined,
}

export const reducer = (state: IMainState = initialMainState, action: ActionWithPayload<IMainState>) => {
  switch (action.type) {
    case actionTypes.DashboardsRequested: {
      return { ...state, loading: true, error: undefined }
    }

    case actionTypes.DashboardsLoaded: {
      const dashboards = action.payload?.dashboards || []
      return { ...state, dashboards, loading: false, error: undefined }
    }

    case actionTypes.DashboardsFailed: {
      const error = action.payload?.error
      return { ...state, loading: false, error }
    }

    case actionTypes.DashboardsCleared: {
      return { ...state, dashboards: [], loading: false, error: undefined }
    }

    default:
      return state
  }
}

export const actions = {
  requestDashboards: () => ({
    type: actionTypes.DashboardsRequested,
  }),
  fulfillDashboards: (dashboards: string[]) => ({
    type: actionTypes.DashboardsLoaded,
    payload: { dashboards },
  }),
  failDashboards: (error: string) => ({
    type: actionTypes.DashboardsFailed,
    payload: { error },
  }),
  clearDashboards: () => ({
    type: actionTypes.DashboardsCleared,
  }),
}

const normalizeDashboards = (value: unknown): string[] => {
  if (!Array.isArray(value)) return []

  return value
    .map((item) => {
      if (typeof item === 'string') return item
      if (item && typeof item === 'object') {
        const obj = item as { code?: unknown; name?: unknown }
        if (typeof obj.code === 'string') return obj.code
        if (typeof obj.name === 'string') return obj.name
      }
      return ''
    })
    .filter(Boolean)
}

export const fetchDashboardsByUserThunk = (userId?: string | number) => async (dispatch: any) => {
  if (!userId) {
    dispatch(actions.clearDashboards())
    return
  }

  try {
    dispatch(actions.requestDashboards())
    const response = await getEmployeeDashboardsByUser(userId)
    const dashboards = normalizeDashboards(response?.data?.dashboards)
    dispatch(actions.fulfillDashboards(dashboards))
  } catch (error: any) {
    dispatch(actions.failDashboards(error?.message || 'Failed to load dashboards'))
  }
}
